export const formatZipCode = (sites, setZipCode) => {
    const sitesCopy = { ...sites }
    if (sites.ZipCode !== 0) {
        const zipCode = sitesCopy.ZipCode.split('').length === 4 ? "0" + sites.ZipCode.toString() : sites.ZipCode.toString()
        setZipCode(zipCode)
    }
}